import Vue from "vue"
import Vuetify from "vuetify/lib"
import ru from "vuetify/lib/locale/ru"
import en from "vuetify/lib/locale/en"
import tailwind from "../../tailwind.config"
import { getInitialLocale } from "@/i18n/locale"

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { ru, en },
    current: getInitialLocale(),
  },
  theme: {
    themes: {
      light: {
        primary: tailwind.theme.colors.green,
        error: tailwind.theme.colors.red,
      },
      dark: {
        primary: tailwind.theme.colors.green,
        error: tailwind.theme.colors.red,
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 640,
      sm: 768,
      md: 1024,
      lg: 1280,
    },
    scrollBarWidth: 0,
  },
})
